<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-body">
        <b-tabs pills justified nav-class="bg-light" content-class="p-3 text-muted mx-4">
          <b-tab class="border-0">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block my-2">Delivery Zones</span>
            </template>
            <delivery-zone-component/>
          </b-tab>
          <b-tab active class="border-0">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block my-2">Timezones</span>
            </template>
            <timezone-component/>
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <span class="d-none d-sm-inline-block my-2">Day Zone Assignments</span>
            </template>
            <day-zone-component/>
          </b-tab>
          <b-tab class="border-0">
            <template v-slot:title>
              <span class="d-none d-sm-inline-block my-2">Public Holidays</span>
            </template>
            <public-holiday-component/>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import TimezoneComponent from "@/components/settings/timezone-component";
import PublicHolidayComponent from "@/components/settings/public-holiday-component";
import DayZoneComponent from "@/components/settings/day-zone-component";
import DeliveryZoneComponent from "@/components/settings/delivery-zone-component";

export default {
  page: {
    title: "System Settings",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    DeliveryZoneComponent, DayZoneComponent, PublicHolidayComponent, TimezoneComponent, PageHeader, Layout},
  name: "system-settings",
  data() {
    return {
      title: "System Settings",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "System Settings",
          active: true
        }
      ],
    }
  },

}
</script>

<style scoped>

</style>
